import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  CONTACT_LIST,
  DETAIL_CONTACT,
  REPLY_CONTACT,
  DELETE_CONTACT,
} from "../actions/contact.actions.types";

const call = Effects.call;

function* getContactList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "contacts/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* contactDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `contacts/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* replyContact({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `contacts/replay/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteContact({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `contacts/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Contact() {
  yield all([
    takeLatest(CONTACT_LIST, getContactList),
    takeLatest(DETAIL_CONTACT, contactDetails),
    takeLatest(REPLY_CONTACT, replyContact),
    takeLatest(DELETE_CONTACT, deleteContact),
  ]);
}

export default Contact;
